import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './emptyContainer.scss';

export default class EmptyContainer extends Component {
  render() {
    return (
    <div className="empty-container">
            <h3>{this.props.title}</h3>
            <p>{this.props.description}</p>
        </div>
    );
  }
}

EmptyContainer.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
}

EmptyContainer.defaultProps = {
    title: '',
    description: '',
}


// WEBPACK FOOTER //
// ./src/shared/components/EmptyContainer.js